import { asyncCallRoutePost } from '../helpers/api';

export class LoadButton {
	constructor( element ) {
		this.button = element;

		const { routeUrl, _wpnonce } = window.QalaSaveShareCart.loadCartRouteObj;

		this.routeUrl = routeUrl;
		this._wpnonce = _wpnonce;
	}

	/**
	 * Initialize the component, setup all event listeners and such.
	 *
	 * @return {void}
	 */
	init() {
		this.button.disabled = false;
		this.button.addEventListener( 'click', this.handleLoadButtonClick.bind( this ) );
	}

	/**
	 * Handle the click event on the load button.
	 *
	 * @param {Object} event Click event
	 * @return {void}
	 */
	handleLoadButtonClick( event ) {
		event.preventDefault();
		this.loadCart();
	}

	/**
	 * Load the cart by sending the request.
	 *
	 * @return {void}
	 */
	async loadCart() {
		try {
			const response = await this.startLoad();

			this.validateResponse( response );
			this.endLoad();
		} catch ( error ) {
			this.handleLoadErrors( error );
		}
	}

	/**
	 * Validates that the response was actually a success.
	 *
	 * @param {Object} response Response object
	 * @return {void}
	 */
	validateResponse( response ) {
		if ( ! response.status ) {
			throw new Error( response?.message || 'Unknown error' );
		}

		if ( response.status !== 200 ) {
			throw new Error( response?.message || 'Unknown error' );
		}
	}

	/**
	 * Starts the load process.
	 *
	 * @return {Promise} Promise object.
	 */
	async startLoad() {
		return asyncCallRoutePost( this.routeUrl, this._wpnonce, { cartId: this.getCartId() } );
	}

	/**
	 * Ends the load process.
	 *
	 * @return {void}
	 */
	endLoad() {
		// Update the Qala MiniCart quantity.
		wp.hooks.doAction( 'QALA_MINICART_FORCE_BACKGROUND_CART_UPDATE' );

		// Trigger the Qala MiniCart button click event if it exists and open cart.
		const qalaMiniCartButton = document.querySelector( '[data-mini-cart-button]' );
		if ( qalaMiniCartButton ) {
			qalaMiniCartButton.click();
		}
	}

	/**
	 * Handles load errors.
	 *
	 * @param {string} error
	 * @return {void}
	 */
	handleLoadErrors( error ) {
		console.error( 'Error loading cart:', error ); // eslint-disable-line no-console
	}

	/**
	 * Get the cart ID from the input field.
	 *
	 * @return {string} Cart ID
	 */
	getCartId() {
		return this.button.getAttribute( 'data-cart' );
	}
}
